import React, {
    MutableRefObject,
    useCallback,
    useEffect,
    useState,
} from "react";
import { LinkSolidIcon } from "@icons/LinkSolidIcon";
import { CircleXMarkIcon } from "@icons/CircleXMarkIcon";
import {
    ClearLinkoutButton,
    LinkoutEndAdornmentStack,
    PostLinkoutUrlTextField,
    SaveLinkoutButton,
} from "./PostForm.styles";
import { isValidUrl } from "@infrastructure/Helpers/UrlHelper";
import { POST_FORM_TABS } from "./PostFormModal.types";
import { SolidCheckIcon } from "@icons/SolidCheckIcon";

export function LinkoutFieldTab({
    errorText,
    linkoutRef,
    linkoutUrl,
    setLinkoutUrl,
    setTabIndex,
}: {
    errorText: string;
    linkoutRef: MutableRefObject<HTMLInputElement>;
    linkoutUrl: string;
    setLinkoutUrl: (value: string) => void;
    setTabIndex: (value: POST_FORM_TABS) => void;
}) {
    useEffect(() => {
        linkoutRef.current?.focus();
    }, [linkoutRef]);

    const [linkoutFieldValue, setLinkoutFieldValue] = useState(linkoutUrl);
    useEffect(() => {
        setLinkoutFieldValue(linkoutUrl);
    }, [linkoutUrl]);

    const clearInput = useCallback(() => {
        setLinkoutFieldValue("");
        setLinkoutUrl("");
        linkoutRef.current?.focus();
    }, [linkoutRef, setLinkoutUrl]);

    const saveLinkout = useCallback(() => {
        if (isValidUrl(linkoutFieldValue)) {
            setLinkoutUrl(linkoutFieldValue);
        }
    }, [linkoutFieldValue, setLinkoutUrl]);

    return (
        <PostLinkoutUrlTextField
            className={errorText.length ? "_error" : ""}
            fullWidth={true}
            inputRef={linkoutRef}
            variant="outlined"
            autoFocus={true}
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    e.preventDefault();
                    linkoutRef.current?.blur();
                }
            }}
            value={linkoutUrl}
            onChange={(event) => {
                setLinkoutUrl(event.target.value);
            }}
            placeholder={"https://"}
            InputLabelProps={{
                shrink: linkoutUrl?.length > 0,
            }}
            InputProps={{
                startAdornment: (
                    <LinkSolidIcon
                        width="16px"
                        height="16px"
                        color={"var(--community-color-primary-text)"}
                    />
                ),
                endAdornment: (
                    <LinkoutEndAdornmentStack>
                        <ClearLinkoutButton onClick={clearInput}>
                            <CircleXMarkIcon />
                        </ClearLinkoutButton>
                        <SaveLinkoutButton
                            onClick={(e) => {
                                e.preventDefault();
                                saveLinkout();
                                setTabIndex(POST_FORM_TABS.DEFAULT);
                            }}
                            disabled={!isValidUrl(linkoutUrl)}
                        >
                            <SolidCheckIcon />
                        </SaveLinkoutButton>
                    </LinkoutEndAdornmentStack>
                ),
            }}
        />
    );
}
